export default {
  actions: {
    RESET_PASSWORD: 'RESET_PASSWORD',
    RESET_PASSWORD_CURRENT_USER: 'RESET_PASSWORD_CURRENT_USER',
  },
};
